module.exports = __webpack_public_path__ + "static/imgs/big-title.7c72fe3.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/big-title.png
// module id = wply
// module chunks = 1